import { JobDetailStatusEnumLabels, PriorityEnumLabels,WorkModeEnumLabels } from "../enum/enum";

export const getPriorityName = (priority) => {
    return PriorityEnumLabels[priority];
  };
  export const getJobStatusName = (status) => {
    return JobDetailStatusEnumLabels[status];
  };
  export const getWorkModeName = (workmode) => {
    return WorkModeEnumLabels[workmode];
  };
  export const getPermissionRights=(permissions,functionalityName)=> {
    // debugger;

    if (!Array.isArray(permissions)) {
      console.warn("Invalid permissions input:", permissions); // optional for debugging
      return { create: 0, view: 0, edit: 0, delete:0 };
    }
  
    const permission = permissions.find(
      (p) => p.functionalityName === functionalityName
    );
  
    return {
      create: permission?.create ?? 0,
      view: permission?.view ?? 0,
      edit: permission?.edit ?? 0,
      delete: permission?.delete ?? 0,
    };

    // if (!permissions) return { create: 0, view: 0, edit: 0 };
    // const permission = permissions?.find(
    //   (p) => p.functionalityName === functionalityName
    // );
    //debugger;
    //const create=
    // return {
    //   create: permission.create,
    //   view: permission.view,
    //   edit: permission.edit
    // };
  }
  export const getPermissionRightsForMenu=(permission)=> {    
    // debugger;
    if (!permission || Object.keys(permission).length === 0) {
      return false;
    }
    return permission?.create > 0 || permission?.view > 0 || permission?.edit > 0;       
  }

  export const getMailBody = (candidateData, jobCode, selectedOutcome) => {
    var mailBody;
    if(selectedOutcome === "Rejected"){
      mailBody = `Hi ${candidateData?.firstName} ${candidateData?.lastName},\n
      Thank you for taking the time to interview for the ${jobCode} position at our company.\n
      After careful consideration, we regret to inform you that we will not be moving forward with your application for this role.\n
      We truly appreciate your interest and encourage you to apply for future openings that match your skills and experience.\n
      Thank you again for your time and effort. We wish you all the best in your job search and future endeavors.\n
      Best regards,\n
      The ZeaRecruit Team`;
    }
    else if(selectedOutcome === "Selected"){
      mailBody = `Hi ${candidateData?.firstName} ${candidateData?.lastName},\n
      Congratulations! We are pleased to inform you that you have been selected for the ${jobCode} position at our company.\n
      Your skills, experience, and performance during the interview process have impressed us, and we believe you will be a valuable addition to our team.\n
      We will be sending you a formal offer letter shortly with all the details regarding your compensation, benefits, and start date.\n
      Please feel free to reach out if you have any questions in the meantime.\n
      Welcome to the team!\n
      Best regards,\n
      The ZeaRecruit Team`;
    } 
    return mailBody;
  } 
